// src/utils/sentDocumentCopies.js — docpdf-8a4c1e73
// Which saved email copies to list: only emails that really went ('sent' — a 'sending' one may still fail,
// a 'failed' one kept no copy), newest first. Pure, so it is tested without Firebase.
const ms = (t) => (t && typeof t.toMillis === 'function' ? t.toMillis() : (t instanceof Date ? t.getTime() : 0));

export const sentCopyRows = (records) => (Array.isArray(records) ? records : [])
    .filter((r) => r && r.status === 'sent')
    .sort((a, b) => ms(b.sentAt) - ms(a.sentAt))
    .map((r) => ({ id: r.id, sentAt: r.sentAt || null, to: r.to || null, ccCount: Array.isArray(r.cc) ? r.cc.length : 0 }));
